import * as angular from 'angular';

class PanelSectionController {}

export const PanelSectionComponent: angular.IComponentOptions = {
  controller: PanelSectionController,
  controllerAs: 'ctrl',
  bindings: {},
  transclude: true,
  template: `
    <ng-transclude />
  `,
};
